import { render } from "./confirmDelete.vue?vue&type=template&id=a550c736&scoped=true"
import script from "./confirmDelete.vue?vue&type=script&lang=js"
export * from "./confirmDelete.vue?vue&type=script&lang=js"

import "./confirmDelete.vue?vue&type=style&index=0&id=a550c736&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a550c736"]])

export default __exports__